import React from 'react';
import classnames from 'classnames';

import styles from './PartsPicker.scss';
import { CdnContext } from '../context';

const Part = ({
    part, slug, title, subTitle, disabled, className,
}) => (
    <div
        className={classnames(className, {
            'disabled-part': disabled,
        })}
    >
        <a href={!disabled ? `#/${slug}` : '/zelfhulptool#/'}>
            <div>
                <CdnContext.Consumer>
                    {cdn => (
                        <img
                            src={`${cdn}assets/images/part-icons/${part}.png`}
                            alt=""
                            className="part-icon"
                        />
                    )}
                </CdnContext.Consumer>
                <h6 className={styles.subHeading}>{subTitle}</h6>
                <h5 className={styles.heading}>{title}</h5>
            </div>
        </a>
    </div>
);

export default Part;



// WEBPACK FOOTER //
// ./src/components/Part.js